import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { HttpInterceptorService, RESTService } from '@covalent/http';
import { MOCK_API } from '../config/api.config';
import { environment } from '../environments/environment';
import 'rxjs/add/operator/map';
import { Diagnostico } from '../models/';

@Injectable()
export class DiagnosticosService extends RESTService<any> {

  constructor(private _http: HttpInterceptorService) {
    super(_http, {
      baseUrl: MOCK_API,
      path: '/resumenPaciente',
    });
  }

  obtenerDiagnosticos(idPaciente: string): any {
    return this._http.post(environment.api_host + 'diagnosticos/obtenerDiagnosticosPaciente', { idPaciente: idPaciente })
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Service error'));
  }

  nuevoDiagnosticoPaciente(params: any): Observable<boolean> {
    return this._http.post(environment.api_host + 'diagnosticos/nuevoDiagnosticoPaciente', params).map((res: Response) => {
      let respuesta: any = res.json();
      if (respuesta.respuesta.resultado === 'OK') {
        return true;
      } else {
        return false;
      }
    }).catch((error: any) => Observable.throw(false));
  }

  cerrarDiagnosticoPaciente(params: any): Observable<boolean> {
    return this._http.post(environment.api_host + 'diagnosticos/cerrarDiagnosticoPaciente', params).map((res: Response) => {
      let respuesta: any = res.json();
      if (respuesta.respuesta) {
        return true;
      } else {
        return false;
      }
    }).catch((error: any) => Observable.throw(false));
  }

}



// WEBPACK FOOTER //
// ./src/services/diagnosticos.service.ts